import { LicenseState } from '@/enums/licenseState';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { Person } from '@/interfaces/person';
import { CommonService } from '@/services/common/common.service';
import { PersonService } from '@/services/person/person.service';
import { RequirementService } from '@/services/requirement/requirement.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { deofuscate } from '@/utils/obfuscation';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  templateUrl: './select-license.component.html',
  styleUrls: ['./select-license.component.css'],
})
export class SelectLicenseComponent implements OnInit {

  requestType: 'personal' | 'third' = 'third';
  selectedPersonData?: Person;

  selectedLicense: Partial<CompleteLicense> = {};
  licenses: CompleteLicense[] = [];
  gettingLicenses: boolean = true;
  gettingLicensesError: string = 'DEFAULT_VALUE';
  zonesRows: Array<number[]> = [];
  sanctionType = '';
  shouldActiveButton: boolean[] = [];
  haveAnActiveRequirement: boolean[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<StoreState>,
    private commonService: CommonService,
    private personService: PersonService,
    private requirementService: RequirementService,
  ) { }

  ngOnInit(): void {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      if (!params) {
        this.requestType = 'personal';
        getCurrentUserData(this.store).subscribe({
          next: (userData) => {
            this.selectedPersonData = userData;
            this.getLicenses(userData.mdmid);
          },
        });
      }
      else {
        this.requestType = 'third';
        this.personService.getPersonDataById(params.personId).subscribe({
          next: (personData) => {
            this.selectedPersonData = personData;
            this.getLicenses(personData.mdmid);
          },
        });
      }
    });
  }

  getLicenses(mdmid: string) {
    this.gettingLicenses = true;
    this.commonService.getLicenseByUser(mdmid)
      .subscribe({
        next: (res) => {
          this.licenses = res.sort((a, b) => {
            if (a.asset.name > b.asset.name) {
              return 1;
            }
            if (a.asset.name < b.asset.name) {
              return -1;
            }
            return 0;
          });

          this.licenses.map((license, index) => {
            const isARedLicense = this.isARedLicense(index);
            this.getLicensesActiveRequirement(license.asset.id).subscribe({
              next: ({ exist }) => {
                this.shouldActiveButton[index] = !(isARedLicense || exist);
                this.haveAnActiveRequirement[index] = exist;
              },
            });
          });

          this.gettingLicenses = false;
          this.getZonesRows();
        },
        error: () => {
          this.gettingLicenses = false;
          this.gettingLicensesError = 'ERROR';
        },
      });
  }

  getZonesRows() {
    this.licenses.forEach((license) => {
      const zonesRowsByAsset: number[] = [];
      license.equipments.forEach((vehicle) => {
        const zonesLength = vehicle.conductionZones.length;
        zonesRowsByAsset.push(Math.ceil(zonesLength / 2));
      });
      this.zonesRows.push(zonesRowsByAsset);
    });
  }

  getLicensesActiveRequirement(assetId: number) {
    return this.requirementService
      .validateExistingExtendRequeriment({
        mdmid: this.selectedPersonData?.mdmid as string,
        assetId,
        requirementType: 2,
      });
  }

  onSelectLicense(licenseId: number, index: number) {
    this.router.navigateByUrl('/license/extend/form', {
      state: {
        license: this.licenses.find((license) => license.id === licenseId),
        licenseZones: [this.zonesRows[this.zonesRows.findIndex((zone, i) => i === index)]],
        person: this.selectedPersonData,
        variant: this.requestType,
      },
    });
  }

  isARedLicense(index: number) {
    const redStatus: LicenseState[] = [
      LicenseState.SUSPENDIDA,
      LicenseState.CADUCADA,
      LicenseState.SANCIONADO,
    ];
    const sanctionTypeLicense = this.licenses[index].sanction?.sanctionType || 'Vigente';
    const sanctionTypeEquipment = this.licenses[index]?.equipments[0].equipmentStatus || 'Vigente';

    let sanctionType = 'Vigente';

    if (redStatus.includes(sanctionTypeLicense as LicenseState)) {
      sanctionType = sanctionTypeLicense;
    }
    else if (redStatus.includes(sanctionTypeEquipment as LicenseState)) {
      sanctionType = sanctionTypeEquipment;
    }

    this.sanctionType = sanctionType;

    return redStatus.includes(sanctionType as LicenseState);
  }

}
